'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _CourseEnrollment = require('./CourseEnrollment');

var _CourseEnrollment2 = _interopRequireDefault(_CourseEnrollment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Represents a page of Course Enrollments
 * @param {Array<CourseEnrollment>} page.items array of course enrollments
 * @param {number} page.count number of items returned
 * @param {Object} page.lastKey key of the last returned item
 */


var CourseEnrollmentsPage = function CourseEnrollmentsPage(fields) {
  (0, _classCallCheck3.default)(this, CourseEnrollmentsPage);

  if (!fields) {
    return;
  }

  if (fields.items !== undefined) {
    this.items = fields.items.map(function (item) {
      return new _CourseEnrollment2.default(item);
    });
  }

  if (fields.count !== undefined) {
    this.count = fields.count;
  }

  if (fields.lastKey !== undefined) {
    this.lastKey = fields.lastKey;
  }
};

exports.default = CourseEnrollmentsPage;